module.exports = __webpack_public_path__ + "img/avatar-m.bd92399b.svg";